// Ilustraciones SVG originales de "Jardín de Mariposas".
// Usan las variables del tema. Sin personajes comerciales.

export function Mariposa({ clase = "", color = "var(--km-primario)", ala = "var(--km-acento)" }) {
  return (
    <svg className={`km-mariposa ${clase}`} viewBox="0 0 80 60" aria-hidden="true">
      <g className="km-mariposa-alas">
        <path d="M38 30 Q6 2 6 22 Q6 40 36 36 Z" fill={color} />
        <path d="M38 32 Q12 34 14 48 Q16 58 37 40 Z" fill={ala} />
        <path d="M42 30 Q74 2 74 22 Q74 40 44 36 Z" fill={color} />
        <path d="M42 32 Q68 34 66 48 Q64 58 43 40 Z" fill={ala} />
      </g>
      <ellipse cx="40" cy="32" rx="3" ry="12" fill="var(--km-texto)" />
      <path d="M37 20 Q34 14 31 12 M43 20 Q46 14 49 12" stroke="var(--km-texto)" strokeWidth="2" fill="none" strokeLinecap="round" />
    </svg>
  );
}

export function Flor({ clase = "", centro = "var(--km-acento)", petalos = "var(--km-primario)" }) {
  return (
    <svg className={`km-flor ${clase}`} viewBox="0 0 60 60" aria-hidden="true">
      {[0, 72, 144, 216, 288].map((ang) => (
        <ellipse
          key={ang}
          cx="30"
          cy="14"
          rx="8"
          ry="13"
          fill={petalos}
          transform={`rotate(${ang} 30 30)`}
        />
      ))}
      <circle cx="30" cy="30" r="8" fill={centro} />
    </svg>
  );
}

// Insignia de edad: una flor con el número en el centro.
export function FlorEdad({ numero, texto }) {
  return (
    <div className="km-floredad" data-testid="km-edad">
      <Flor clase="km-floredad-flor" petalos="var(--km-primario)" centro="var(--km-acento)" />
      <span className="km-floredad-centro">
        <span className="km-floredad-numero">{numero}</span>
        <span className="km-floredad-texto">{texto}</span>
      </span>
    </div>
  );
}
